import { Injectable } from '@angular/core';
import { GungMainMenuService, GungMenu, GungMenuItem } from '../../../services/gung-main-menu/gung-main-menu.service';
import { AMAZON_FINANCE_FEATURE_ID } from './amazon-finance-feature';

@Injectable({ providedIn: 'root' })
export class AmazonFinanceMainMenuService extends GungMainMenuService {
  override getStandardMenuGroupsWithoutLinks(): GungMenu[] {
    const menus = super.getStandardMenuGroupsWithoutLinks();
    const adminIndex = menus.findIndex(menu => menu.heading === 'ADMIN');
    menus.splice(adminIndex < 0 ? menus.length : adminIndex, 0, {
      heading: 'AMAZON_FINANCE',
      icon: 'fa-brands fa-amazon',
      open: false
    });
    return menus;
  }

  override getStandardMenuItems(): GungMenuItem[] {
    return [
      ...super.getStandardMenuItems(),
      {
        id: 'AMAZON_FINANCE_CONSOLE',
        title: 'AMAZON_FINANCE_CONSOLE',
        pagePath: '/admin/amazon-finance',
        groupId: 'AMAZON_FINANCE',
        iconCss: 'fa-solid fa-file-invoice-dollar',
        dependantOnFeatureId: AMAZON_FINANCE_FEATURE_ID,
        sortingPriority: 40000,
        visibleForRoles: { ADMIN: true, ACTUATOR: true }
      }
    ];
  }
}
